import { useEffect } from 'react';

export function useOnMount(setupFn: () => void) {
    useEffect(() => {
        setupFn();
    }, []); // oxlint-disable-line react-hooks/exhaustive-deps -- Mount effects do not have deps
}
